<template>
	<section>
		<!--顶部工具条-->
		<el-col :span="24">
			<el-form :inline="true">
<!--				<el-form-item label="关键字:">-->
<!--					<el-input v-model="filters.name" @input="(e) => (filters.name = utils.validForbid(e))" placeholder="请输入内容" @clear='clearContent' clearable ></el-input>-->
<!--				</el-form-item>-->
				<!-- <el-form-item label="组织机构:" width>
					<el-cascader
						placeholder="请选择，支持搜索功能"
						style="width: 100%"
						v-model="OptionTreec"
						:options="options"
						:props="defaultProps"
						filterable
						change-on-select
					>
					</el-cascader>
				</el-form-item> -->
				<el-form-item label="问题类型:">
					<el-select v-model="filters.problemType">
						<el-option
								v-for="item in optionsType"
								:key="item.value"
								:label="item.name"
								:value="item.value"
						>
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="是否处理:">
					<el-select v-model="filters.isHandled">
						<el-option
								v-for="item in statusList"
								:key="item.value"
								:label="item.name"
								:value="item.value"
						>
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>
				</el-form-item>
			</el-form>
		</el-col>
		<!--列表-->
		<el-table
				:data="tableData"
				border
				highlight-current-row
				v-loading="listLoading"
				@current-change="selectCurrentRow"
				style="width: 100%;"
		>
			<el-table-column type="index" label="序号" width="80" align="center" :index='indexMethod'></el-table-column>
			<el-table-column prop="problemType" label="问题类型"  align="center">
				<template slot-scope="scope">
					<el-tag v-if="scope.row.problemType == 1"  disable-transitions>{{'操作体验'}}</el-tag>
					<el-tag v-if="scope.row.problemType == 2"  disable-transitions>{{'页面问题'}}</el-tag>
					<el-tag v-if="scope.row.problemType == 3"  disable-transitions>{{'闪退卡顿'}}</el-tag>
					<el-tag v-if="scope.row.problemType == 4"  disable-transitions>{{'优化建议'}}</el-tag>
					<el-tag v-if="scope.row.problemType == 5"  disable-transitions>{{'其他'}}</el-tag>
				</template>
			</el-table-column>
			<el-table-column prop="feedbackContent" label="反馈内容"   align="center"></el-table-column>
			<el-table-column prop="feedbackTime" label="发送时间"  align="center"></el-table-column>
			<el-table-column prop="replyContent" label="回复内容"   align="center"></el-table-column>
			<el-table-column prop="createTime" label="是否处理"   align="center">
				<template slot-scope="scope">
					<el-tag :type="scope.row.isHandled  ? 'success' : 'danger'" disable-transitions>{{scope.row.isHandled ? "是":"否"}}</el-tag>
				</template>
			</el-table-column>
			<el-table-column prop="handledTime" label="处理时间"   align="center"></el-table-column>
		</el-table>
		<!--底部工具条-->
		<el-col :span="24" class="pageBar">
			<el-pagination
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:current-page="pages.pageIndex"
					:page-sizes="pages.pageArr"
					:page-size="pages.pageSize"
					layout="total, sizes, prev, pager, next, jumper"
					:total="pages.dataCount">
			</el-pagination>
		</el-col>
		<!--新增界面-->
		<el-dialog
				title="回复反馈"
				:visible.sync="addFormVisible"
				v-model="addFormVisible"
				:close-on-click-modal="false"
		>
			<el-form :model="addForm" label-width="180px" :rules="addFormRules" ref="addForm">
				<el-form-item label="操作体验:" >
					{{ currentRow ? (problemTypeMap[currentRow.problemType] || '其他') : '其他' }}
				</el-form-item>
				<el-form-item label="反馈内容:" >
					{{currentRow?currentRow.feedbackContent:''}}
				</el-form-item>
				<el-form-item label="回复内容:" prop="replyContent">
					<el-input
							type="textarea"
							:rows="3"
							style="width: 80%"
							placeholder="请输入内容"
							v-model="addForm.replyContent">
					</el-input>
				</el-form-item>
				<el-form-item label="是否处理:" prop="isHandled">
					<el-radio-group v-model="addForm.isHandled">
						<el-radio :label="true">是</el-radio>
						<el-radio :label="false">否</el-radio>
					</el-radio-group>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="addFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
			</div>
		</el-dialog>
		
	</section>
</template>
<script>
import {
	getRoleListPage,
	addRoleInfo,
	updateRoleInfo,
	deleteRoleInfo,
	getOrganizationTree,
	getAppProblemListPage, addAppProblemReply
} from "../../api/api";
import util from "../../../util/date";
import Toolbar from "../../components/Toolbar";
import { getButtonList } from "../../promissionRouter";
import Qs from 'qs'
export default {
	components: { Toolbar },
	data() {
		return {
			problemTypeMap: {
				1: '操作体验',
				2: '页面问题',
				3: '闪退卡顿',
				4: '优化建议'
			},
			utils: '',
			pages: {  //关于分页的obj
				pageSize: 20,//默认每页条数
				pageArr: [10, 20, 30, 40],//默认每页条数选择
				pageIndex: 1, //默认进入页
				dataCount: 20, //默认总页数
			},
			filters: { //顶部筛选条件
				problemType: undefined,
				isHandled: undefined
			},
			optionsType: [
					{
						value: '1',
						label: '操作体验'
					},
					{
						value: '2',
						label: '页面问题'
					},
					{
						value: '3',
						label: '闪退卡顿'
					},
					{
						value: '4',
						label: '优化建议'
					},
					{
						value: '5',
						label: '其他'
					},
			],
			//是否启用状态
			statusList: [{
				value: true,
				name: '启用'
			},{
				value: false,
				name: '禁用'
			}],
			tableData: [],//角色信息列表
			currentRow: null,
			listLoading: false,
			buttonList: [],
			//新增界面数据
			addForm: {
				replyContent:undefined,
				isHandled:undefined,
				id:undefined,
			},
			OptionTree: '',
			OptionTreec: [],
			addFormRules: {
				replyContent: [{ required: true, message: "请输入内容", trigger: "blur" }],
				isHandled: [ { required: true, message: '请选择状态', trigger: 'change' }],
				// OptionTree: [{ required: true, message: '请选择组织机构', trigger: 'blur' }]
			},
			addFormVisible: false, //新增界面是否显示
			addLoading: false,
			//编辑界面数据
			editForm: {
				id: 0,
				name: "",
				isEnable: false,
				remarks:"",
				sortNo: '',
				organizationInfoName: '',
			},
			editFormVisible: false, //编辑界面是否显示
			editLoading: false,
			editFormRules: {
				name: [{ required: true, message: "请输入角色名", trigger: "blur" }],
				isEnable: [{ required: true, message: "请选择状态", trigger: "blur" }]
			},
			// 组织结构树数据
			defaultProps: {
				children: "children",
				label: "name",
				value:'id' //可要可不要
			},
			options: []
		};
	},
	methods: {
		// 清空筛选项，重新获取数据
		clearContent(){
			this.getData()
		},
		//
		selectCurrentRow(val) {
			this.currentRow = val;
		},
		//获取角色信息分页列表
		getData() {
			let _this = this;
			var params = {
				pageIndex: this.pages.pageIndex,
				pageSize: this.pages.pageSize,
				problemType: this.filters.problemType,
				isHandled: this.filters.isHandled
			};
			
			this.listLoading = true;
			getAppProblemListPage(params).then(res => {
				this.tableData = res.data.response.data;
				this.listLoading = false;
				this.pages.dataCount = res.data.response.dataCount
				this.pages.pageIndex = res.data.response.pageIndex
				if(res.data.response.pageSize > 0){
					this.pages.pageSize = res.data.response.pageSize
				}
			});
		},
		// 分页
		handleCurrentChange(val) {
			// if(this.filters.name != '' || this.filters.selectc != true){
			//   this.pages.pageIndex = 1
			// }else{
			this.pages.pageIndex = val;
			// }
			this.getData();
		},
		handleSizeChange(val){
			this.pages.pageSize = val
			this.getData();
		},
		callFunction(item) {
			this[item.func].apply(this, item);
		},
		//时间格式化
		formatCreateTime: function(row, column) {
			return !row.createTime || row.createTime == ""
					? ""
					: util.formatDate.format(new Date(row.createTime), "yyyy-MM-dd");
		},
		// 回车按钮
		enterKey(item) {
			if(item == 1){
				this.addSubmit();
			}else if(item == 2){
				this.editSubmit();
			}
		},
		//显示新增界面
		userFeedback() {
			if (!this.currentRow){
				this.$message({
					message: '请选择一条数据',
					type: 'warning'
				});
				return
			}
			console.log(this.currentRow,'ccccccccccccccc')
			this.addFormVisible = true;
			this.addForm = {
				replyContent:undefined,
				isHandled:undefined,
				id:undefined,
			};
		},
		// 查询
		getListData(){
			this.pages.pageIndex = 1
			this.getData()
		},
		//新增
		addSubmit: function() {
			let _this = this;
			this.$refs.addForm.validate(valid => {
				if (valid) {
					this.$confirm("确认提交吗？", "提示", {}).then(() => {
						this.addLoading = true;
						let para = {
							id:this.currentRow.id,
							replyContent:this.addForm.replyContent,
							isHandled:this.addForm.isHandled
						}
						
						addAppProblemReply(para).then(res => {
							if (util.isEmt.format(res)) {
								this.addLoading = false;
								return;
							}
							if (res.data.success) {
								this.addLoading = false;
								//NProgress.done();
								this.$message({
									message: res.data.message,
									type: "success"
								});
								this.$refs["addForm"].resetFields();
								this.addFormVisible = false;
								this.getListData();
							} else {
								this.$message({
									message: res.data.message,
									type: "error"
								});
							}
						});
					});
				}
			});
		},
		//显示编辑界面
		handleEdit() {
			let row = this.currentRow;
			if (!row) {
				this.$message({
					message: "请选择要编辑的一行数据！",
					type: "error"
				});
				return;
			}
			this.editFormVisible = true;
			this.editForm = Object.assign({}, row);
		},
		//编辑
		editSubmit: function() {
			this.$refs.editForm.validate(valid => {
				if (valid) {
					this.$confirm("确认提交吗？", "提示", {}).then(() => {
						this.editLoading = true;
						let para = Object.assign({}, this.editForm);
						updateRoleInfo(para).then(res => {
							if (util.isEmt.format(res)) {
								this.editLoading = false;
								return;
							}
							if (res.data.success) {
								this.editLoading = false;
								//NProgress.done();
								this.$message({
									message: res.data.message,
									type: "success"
								});
								this.$refs["editForm"].resetFields();
								this.editFormVisible = false;
								this.getData();
							} else {
								this.$message({
									message: res.data.message,
									type: "error"
								});
							}
						});
						
					});
				}
			});
		},
		//删除
		handleDel() {
			let row = this.currentRow;
			if (!row) {
				this.$message({
					message: "请选择要删除的一行数据！",
					type: "error"
				});
				return;
			}
			this.$confirm("确认删除该记录吗?", "提示", {
				type: "warning"
			}).then(() => {
						this.listLoading = true;
						let params = { id: row.id };
						deleteRoleInfo(params).then(res => {
							if (util.isEmt.format(res)) {
								this.listLoading = false;
								return;
							}
							this.listLoading = false;
							if (res.data.success) {
								this.$message({
									message: "删除成功",
									type: "success"
								});
							} else {
								this.$message({
									message: res.data.message,
									type: "error"
								});
							}
							this.getData();
						});
					})
					.catch(() => {});
		},
		
		// 获取树结构数据
		getOrganizations() {
			var _this = this
			var ID = JSON.parse(localStorage.getItem("user")).ID
			var params = {
				parentId: 0
			}
			getOrganizationTree(params).then(res => {
				var data = res.data
				var resData = [data.response]
				if(data.success){
					if(data.response.name == "根节点"){
						_this.options = data.response.children
					}else{
						_this.options = resData
					}
				}
			})
		},
		// 表格数据分页条数累计
		indexMethod(index) {
			var currentPage = this.pages.pageIndex
			var pageSize = this.pages.pageSize
			return (index + 1) + (currentPage - 1) * pageSize
		},
	},
	mounted() {
		this.utils = util
		//首次加载角色信息列表
		this.getData();
		let routers = window.localStorage.router  ? JSON.parse(window.localStorage.router) : [];
		this.buttonList = getButtonList(this.$route.path, routers);
		this.getOrganizations();
	},
};
</script>
<style lang="stylus" scoped>
.rolesTop{
	width 100%;
	display flex;
}
.rolesInp{
	width 300px;
	margin-right 20px;
}
.pageBar{
	margin-top 15px;
}
.bold-font {
	font-weight: bold;
}
</style>